import { useVerifyCode, useVerifyUser, useUpdateEmail } from "../../api/query_hooks";
import { useCreateAddress, useDeleteAddress } from "../../api/query_hooks/address";
import PanelCardHeader from "../../components/layout/panel/PanelCardHeader";
import { Button, CardBody, Col, Form, ListGroup } from "react-bootstrap";
import PanelCard from "../../components/layout/panel/PanelCard";
import Panel from "../../components/layout/panel/Panel";
import { useState } from "react";
import 'boxicons';

const AccountDetails = ({user, addresses}) => {

    return (
        <Panel className="py-5 ps-0 pe-md-3">
            <PersonalnfoCard user={user} />
            <AddressCard addresses={addresses} />
        </Panel>
    );
}

const PersonalnfoCard = ({user}) => {

    const [option, setOption] = useState(0);
    // const [firstName, setFirstName] = useState(user?.firstName);
    // const [lastName, setLastName] = useState(user?.lastName);
    const [email, setEmail] = useState(user?.email);
    const [code, setCode] = useState("");

    const verificationMutation = useVerifyUser();
    const codeMutation = useVerifyCode();
    const emailMutation = useUpdateEmail();

    const updateEmail = (e) => {
        e.preventDefault();

        emailMutation.mutate({email});
        setOption(3);
    }

    const generateCode = () => {
        codeMutation.mutate();
        setOption(3);
    }

    const verifyUser = (e) => {
        e.preventDefault();

        verificationMutation.mutate({code});
        setOption(0);
    }


    return (
        <PanelCard header={"Account details"}>
            <ListGroup className="col-12 px-2 py-2 py-md-4">

                {/* <ListGroup.Item className="bg-dark text-white-50 d-flex flex-column flex-md-row hov-bg-1">
                    <Col className="text-white-50 col-6 col-md-4 user-select-none">Name</Col>
                    <Col className="d-flex justify-content-between align-content-center">
                        {(option !== 1 &&
                            <>
                                <span>{user?.firstName+' '+user?.lastName}</span>
                                <Button variant="link" className="p-0 m-0" onClick={() => setOption(1)} aria-describedby="edit name">
                                    <box-icon color='white' name='edit-alt' type='solid' ></box-icon>
                                </Button>
                            </>
                        )}
                        {(option === 1 &&
                            <>
                                <Form className="my-1">
                                    <Form.Label className="text-white-50">(First name)</Form.Label>
                                    <Form.Control size="sm" className="bg-darker mb-2 col-2 rounded-0" type="text" defaultValue={firstName} onChange={e => setFirstName(e.target.value)} aria-describedby="first name" />
                                    <Form.Label className="text-white-50">(Last name)</Form.Label>
                                    <Form.Control size="sm" className="bg-darker mb-2 rounded-0" type="text" defaultValue={lastName} onChange={e => setLastName(e.target.value)} aria-describedby="last name" />
                                    <Button variant="warning" size="sm" className="my-1 px-4 px-lg-3" type="submit" aria-describedby="save">Save</Button>
                                </Form>
                                <Button variant="link" className="p-0 m-0" onClick={() => setOption(0)} aria-describedby="close">
                                    <box-icon color='white' name='x' type='solid' ></box-icon>
                                </Button>
                            </>
                        )}
                    </Col>
                </ListGroup.Item> */}

                <ListGroup.Item className="bg-dark text-white-50 d-flex flex-column flex-md-row">
                    <Col className="col-6 col-md-4 user-select-none">
                        <span className="text-white-50">Username</span>
                    </Col>
                    <Col className="d-flex justify-content-between align-content-center">
                        <span className="pb-1">{user?.username}</span>
                    </Col>
                </ListGroup.Item>

                <ListGroup.Item className="bg-dark text-white-50 d-flex flex-column flex-md-row hov-bg-1">
                    <Col className="d-flex align-items-center col-6 col-md-4 user-select-none">
                        <span className="text-white-50">Email</span>
                        {!user?.verified && 
                            <Button variant="link" className="px-2 py-1 m-0 text-decoration-none text-white-50" onClick={generateCode} aria-describedby="edit">
                                (verify)
                            </Button>
                        }
                    </Col>
                    <Col className="d-flex justify-content-between align-content-center">
                        {((option !== 2 && option !== 3) &&
                            <>
                                <span>
                                    {user?.email}
                                </span>
                                <Button variant="link" className="p-0 m-0" onClick={() => setOption(2)} aria-describedby="edit">
                                    <box-icon color='white' name='edit-alt' type='solid' ></box-icon>
                                </Button>
                            </>
                        )}
                        {(option === 2 &&
                            <>
                                <Form onSubmit={updateEmail}>
                                    <Form.Label className="text-white-50">(e-mail)</Form.Label>
                                    <Form.Control size="sm" className="bg-darker mb-2 col-2 rounded-0" type="email" defaultValue={email} onChange={e => setEmail(e.target.value)} aria-describedby="email" />
                                    <Button variant="warning" size="sm" className="my-1 px-4 px-lg-3" type="submit" aria-describedby="save">Save</Button>
                                </Form>
                                <Button variant="link" className="p-0 m-0" onClick={() => setOption(0)} aria-describedby="close">
                                    <box-icon color='white' name='x' type='solid' ></box-icon>
                                </Button>
                            </>
                        )}
                        {(option === 3 &&
                            <>
                                <Form onSubmit={verifyUser}>
                                    <p className="fs-6">Type down the verification code<br/> you received in your email</p>
                                    <Form.Label className="text-white-50">(verification code)</Form.Label>
                                    <Form.Control size="sm" className="bg-darker mb-2 col-2 rounded-0" type="text" placeholder="012345" onChange={e => setCode(e.target.value)} aria-describedby="verification code" />
                                    <Button variant="warning" size="sm" className="my-1 px-4 px-lg-3" type="submit" aria-describedby="save">Submit</Button>
                                </Form>
                                <Button variant="link" className="p-0 m-0" onClick={() => setOption(0)} aria-describedby="close">
                                    <box-icon color='white' name='x' type='solid' ></box-icon>
                                </Button>
                            </>
                        )}
                    </Col>
                </ListGroup.Item>

                <ListGroup.Item className="bg-dark text-white-50 d-flex flex-column flex-md-row hov-bg-1">
                    <Col className="col-6 col-md-4 user-select-none">
                        <span className="text-white-50">Phone</span>
                    </Col>
                    <Col className="d-flex justify-content-between align-content-center">
                        <span className="text-white-50 user-select-none">XXX-XXXX-XXX</span>
                        <Button variant="link" className="p-0" disabled aria-describedby="edit">
                            <box-icon color='white' name='edit-alt' type='solid' ></box-icon>
                        </Button>
                    </Col>
                </ListGroup.Item>

                <ListGroup.Item className="bg-dark text-white-50 d-flex flex-column flex-md-row">
                    <Col className="col-6 col-md-4 user-select-none">
                        <span className="text-white-50">Member since</span>
                    </Col>
                    <Col className="d-flex justify-content-between align-content-center">
                        <span>{(new Date(user?.createdAt)).toLocaleDateString()}</span>
                    </Col>
                </ListGroup.Item>

            </ListGroup>
        </PanelCard>
    );
}

const AddressCard = ({addresses}) => {

    const [province, setProvince] = useState("");
    const [country, setCountry] = useState("");
    const [city, setCity] = useState("");
    const [line, setLine] = useState("");
    const [code, setCode] = useState("");

    const [deleteId, setDeleteId] = useState(0);

    const [editMode, setEditMode] = useState(false);

    const createAddressMutation = useCreateAddress();
    const deleteAddressMutation = useDeleteAddress();

    const createAddress = (e) => {
        e.preventDefault();

        createAddressMutation.mutate(({country, province, city, code, line}));
        setEditMode(false);
    }

    const deleteAddress = (e) => {
        e.preventDefault();

        deleteAddressMutation.mutate(deleteId);
    }


    return (
        <PanelCard>
            <PanelCardHeader>
                <span>Address Info</span>
                {!editMode &&
                    <Button variant="link" className="p-0 m-0" onClick={() => setEditMode(true)} aria-describedby="add address">
                        <box-icon color='white' name='plus-circle'></box-icon>
                    </Button>
                } {
                    editMode &&
                    <Button variant="link" className="p-0 m-0" onClick={() => setEditMode(false)} aria-describedby="remove address">
                        <box-icon color='white' name='minus-circle' ></box-icon>
                    </Button>
                }
            </PanelCardHeader>
            {editMode &&
                <>
                    {!!addresses?.length && <hr className="m-0"></hr>}
                    <Form className="position-relative col-12 px-3 py-2 pt-4 px-lg-4 d-flex flex-column justify-content-center align-items-center" onSubmit={createAddress}>
                        {/* <div className="col-12 d-flex justify-content-end">
                            <Button variant="link" className="p-0 m-0" onClick={() => setEditMode(false)} aria-describedby="close">
                                <box-icon color='white' name='x' type='solid' ></box-icon>
                            </Button>
                        </div> */}
                        <div className="col-12 d-flex flex-column flex-lg-row gap-lg-4 justify-content-center">
                            <Form.Group className="mb-3 d-flex flex-column col-lg-4" controlId="countryBox" >
                                <Form.Label className="text-white-50">Country</Form.Label>
                                <Form.Control size="sm" className="bg-darker rounded-0" type="text" placeholder="USA" onChange={e => setCountry(e.target.value)} aria-describedby="country" />
                            </Form.Group>

                            <Form.Group className="mb-3 d-flex flex-column col-lg-4" controlId="cityBox" >
                                <Form.Label className="text-white-50">City</Form.Label>
                                <Form.Control size="sm" className="bg-darker rounded-0" type="text" placeholder="Seattle" onChange={e => setCity(e.target.value)} aria-describedby="city" />
                            </Form.Group>

                            <Form.Group className="mb-3 d-flex flex-column col-lg-2" controlId="cityBox" >
                                <Form.Label className="text-white-50">Postal code</Form.Label>
                                <Form.Control size="sm" className="bg-darker rounded-0" type="text" placeholder="00000" onChange={e => setCode(e.target.value)} aria-describedby="postal code" />
                            </Form.Group>
                        </div>

                        <div className="col-12 d-flex flex-column flex-lg-row gap-lg-5 justify-content-center">
                            <Form.Group className="mb-3 d-flex flex-column col-lg-3" controlId="addressBox" >
                                <Form.Label className="text-white-50">Province/State</Form.Label>
                                <Form.Control size="sm" className="bg-darker rounded-0" type="text" placeholder="Washington" onChange={e => setProvince(e.target.value)} aria-describedby="address line" />
                            </Form.Group>

                            <Form.Group className="mb-3 d-flex flex-column col-lg-7" controlId="addressBox" >
                                <Form.Label className="text-white-50">Address line</Form.Label>
                                <Form.Control size="sm" className="bg-darker rounded-0" type="text" placeholder="15 Maple St." onChange={e => setLine(e.target.value)} aria-describedby="address line" />
                            </Form.Group>
                        </div>

                        <Button variant="warning" size="sm" className="my-2 px-4 px-lg-3" type="submit" aria-describedby="save">Save</Button>
                    </Form>
                    {!!addresses?.length && <hr className="m-0"></hr>}
                </>
            }
            {!!addresses?.length && addresses?.map((address, index) => {
                return (
                    <div key={index}>
                        <ListGroup className="col-12 px-2 py-2 py-md-4 hov-bg-1 hov-bg-1">
                            <div className="d-flex justify-content-between">
                                <span className="text-bold mx-3 mb-2">Address {index+1}</span>
                                <Form onSubmit={deleteAddress}>
                                    <Button type="submit" variant="link" onClick={() => setDeleteId(address?.id)}>
                                        <box-icon color='white' name='trash'></box-icon>
                                    </Button>
                                </Form>
                            </div>

                            <ListGroup.Item className="bg-transparent text-white-50 d-flex flex-column flex-md-row pt-3">
                                <Col className="text-white-50 col-6 col-md-4 user-select-none">Country</Col>
                                <Col><span>{address.country}</span></Col>
                            </ListGroup.Item>

                            <ListGroup.Item className="bg-transparent text-white-50 d-flex flex-column flex-md-row">
                                <Col className="text-white-50 col-6 col-md-4 user-select-none">State/Province</Col>
                                <Col><span>{address.province}</span></Col>
                            </ListGroup.Item>

                            <ListGroup.Item className="bg-transparent text-white-50 d-flex flex-column flex-md-row">
                                <Col className="text-white-50 col-6 col-md-4 user-select-none">City</Col>
                                <Col><span>{address.city}</span></Col>
                            </ListGroup.Item>

                            <ListGroup.Item className="bg-transparent text-white-50 d-flex flex-column flex-md-row">
                                <Col className="text-white-50 col-6 col-md-4 user-select-none">Address line</Col>
                                <Col><span>{address.address}</span></Col>
                            </ListGroup.Item>

                            <ListGroup.Item className="bg-transparent text-white-50 d-flex flex-column flex-md-row pb-3">
                                <Col className="text-white-50 col-6 col-md-4 user-select-none">Postal code</Col>
                                <Col><span>{address.code}</span></Col>
                            </ListGroup.Item>
                        </ListGroup>
                        {(index+1 < addresses?.length) && <hr className="m-0"></hr>}
                    </div>
                )
            })}
            {(!addresses?.length && !editMode) &&
                <CardBody className="ps-4 py-4 text-white-50 user-select-none">
                    <span className="text-white-50">You haven't added any personal address yet. Click on the plus button to add an address.</span>
                </CardBody>
            }
        </PanelCard>
    );
}


export default AccountDetails;